import alt from 'components/Dispatcher';

import {ActionsBase, DispatchAll, IncludeResultCallbacks} from '@store/@types/alt';
import {Metric, MetricAxis, MetricParams, MetricResponse, MetricFilter} from '@store/@types/metric';

import generateAsyncActions from 'utils/generateAsyncActions';

import NineBoxMetricSource, {FetchMetricReq} from './NineBoxMetricSource';

interface AsyncActions {
  /** @link NineBoxMetricSource
   *        NineBoxMetricStore */
  fetchMetric: (req: FetchMetricReq) => Promise<MetricResponse>;
  fetchTimeInformation: (
    req: MetricFilter
  ) => Promise<{meeting: MetricResponse; review: MetricResponse}>;
}

interface SyncActions {
  setAxisMetric(params: {metricAxis: MetricAxis; metricParams: MetricParams}): void;
  toggleExport(metric: MetricParams, checked: boolean): void;
}

export interface MetricsTrendsActionsInterface
  extends IncludeResultCallbacks<AsyncActions>,
    SyncActions {}

class NineBoxMetricActions
  extends ActionsBase<AsyncActions, SyncActions>()
  implements DispatchAll<AsyncActions>
{
  constructor() {
    super();
    this.generateActions(
      'setAxisMetric',
      'toggleExport',
      ...generateAsyncActions<AsyncActions>('fetchMetric', 'fetchTimeInformation')
    );
  }

  fetchMetric(req: FetchMetricReq) {
    return dispatch => {
      dispatch(req);
      return NineBoxMetricSource.fetchMetric(req).then(
        this.fetchMetricSuccess,
        this.fetchMetricError
      );
    };
  }

  fetchTimeInformation(filter: MetricFilter) {
    return dispatch => {
      dispatch(filter);
      return NineBoxMetricSource.fetchMetric({
        ...filter,
        direction: 'any',
        metric: Metric.MEETING_TIME,
        metricAxis: MetricAxis.HORIZONTAL,
      })
        .then(meeting => {
          return NineBoxMetricSource.fetchMetric({
            ...filter,
            direction: 'any',
            metric: Metric.REVIEW_TIME,
            metricAxis: MetricAxis.VERTICAL,
          })
            .then(review => {
              return this.fetchTimeInformationSuccess({meeting, review});
            })
            .catch(this.fetchTimeInformationError);
        })
        .catch(this.fetchTimeInformationError);
    };
  }
}

export default alt.createActions<AsyncActions, SyncActions>(NineBoxMetricActions);
